import React, { Component } from 'react'
import { injectIntl } from 'react-intl'
import LoadingSpinner from '../../common/spinner/loading.component.jsx'
import { AppContext } from '@lightspeed-invoicing/core-client/frontend'
import SideBar from "../../common/layout/sidebar.component.jsx"
import EventBus from "../../common/EventBus.js"
import CalendarEventAnalytics from "../../scheduling-page/calendareventanalytics.component.jsx";
import EditEvent from "../../scheduling-page/editevent.component.jsx";
const queryString = require('query-string')

class CalendarEventEdit extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            identifier: '',
            calendarEventId: this.props.match.params.calendarEventId,
            calendarEvent: '',
            projectObject: null,
            loading: true,
            modal: '',
            redirect: ''
        }

        this.refreshEvent = this.refreshEvent.bind(this)

    }

    componentDidMount() {
        this.refreshEvent()
        const uri = queryString.parse(this.props.location.search)
        this.setState({
            editMode: uri.em === '1',
        })
        SideBar.activateMenu('schedulingpage')
    }

    refreshEvent(value) {
        let calendarEventId = ''
        if (value && typeof value === "string") {
            calendarEventId = value
        }
        if (calendarEventId && calendarEventId !== this.state.calendarEventId) {
            window.scrollTo(0, 0)
        }
        if (!calendarEventId) {
            calendarEventId = this.state.calendarEventId
        }
        AppContext.getApiClient().get('/calendar-events/' + calendarEventId).then(calendarEvent => {
            if (this.state.calendarEvent.id !== calendarEventId) {
                EventBus.dispatch(EventBus.TopicRefreshCurrentBreadcrumb, {
                    path: `/calendar-events/${calendarEventId}/edit`
                })
            }
            this.setState({
                loading: false,
                calendarEvent: calendarEvent,
                projectObject: calendarEvent.attributes.project
            })

        });

    }

    render() {
        if (this.state.loading) {
            return <LoadingSpinner className="py-2" />
        }

        return (

            <div>
                <CalendarEventAnalytics
                    projectObject={this.state.projectObject}
                    calendarEvent={this.state.calendarEvent}
                    onRefresh={this.refreshEvent}
                />
                <EditEvent
                    calendarEvent={this.state.calendarEvent}
                    onRefresh={this.refreshEvent}
                />
            </div>


        );

    }

}

export default injectIntl(CalendarEventEdit)





// WEBPACK FOOTER //
// ./src/calendar/components/CalendarEventComponent.jsx